import BWPBadge from '@/icons/BWPBadge';

export default function BuyWithPrimeBadge({ className, ...props }) {
  return (
    <div id="bwpContainer" className={className}>
      <BWPBadge className="h-full w-full" />
    </div>
  );
}
